import { useTranslation } from 'react-i18next';
import IconLock from '~icons/bx/lock';
import { EmptySection } from './EmptySection';
export function NoPermissionsSection({
  message
}) {
  const {
    t
  } = useTranslation('permissions');
  return <EmptySection Icon={IconLock} message={message || t('no permission page')} missingPermission />;
}